import React from 'react';

import { TreeViewContent } from './tree-view-content';
import { TreeViewItemModel } from './tree-view-item';
import { TreeViewState } from './tree-view-state';

interface Props {
  items: TreeViewItemModel[];
  expandAll?: boolean;
}

const TreeView = (props: Props) => {
  return (
    <TreeViewState>
      <TreeViewContent expandAll={props.expandAll ?? false} items={props.items} />
    </TreeViewState>
  );
};

export { TreeView };
